import React, { Fragment, useState } from 'react';
import {
  Button,
  useUnselectAll,
  useNotify,
  showNotification,
  refreshView
} from 'react-admin';
import { connect } from 'react-redux';
import InvestorApi from '../../../core/apis/InvestorApi';
import Confirm from '../../../core/components/forked/layout/Confirm';
import { getIcError } from '../../../core/providers/utils';

const RemoveButton = props => {
  const [open, setOpen] = useState(false);

  const handleClick = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const notify = useNotify();
  const unselectAll = useUnselectAll();

  const handleConfirm = async () => {
    try {
      let count = await props.updateMany(props);
      notify('ra.notification.deleted', {
        messageArgs: { smart_count: count }
      });

      unselectAll('investors');
    } catch (error) {
      notify('ra.notification.delete_error', {
        type: 'error',
        messageArgs: { message: getIcError(error) }
      });
    }
    setOpen(false);
  };

  return (
    <Fragment>
      <Button label="Remove" onClick={handleClick} />
      <Confirm
        isOpen={open}
        title="Remove Investors from Family"
        content="Are you sure you want to delete selected investors from Family?"
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
        confirm="ra.action.delete"
      />
    </Fragment>
  );
};

class RemoveOrganizationInvestorButton extends React.Component {
  updateMany = async props => {
    const investors = [];

    const { refreshView } = props;

    if (
      props.selectedIds &&
      props.selectedIds.length > 0 &&
      props.investors &&
      props.investors.data &&
      Object.keys(props.investors.data).length > 0
    ) {
      props.selectedIds.forEach(investor => {
        let visibleInvestors = props.investors.data;
        let initialInvestor = Object.keys(visibleInvestors).find(
          el => el === investor
        );
        if (initialInvestor && visibleInvestors[initialInvestor]) {
          investors.push({
            ...visibleInvestors[initialInvestor],
            organizationId: null
          });
        }
      });
    }

    if (investors.length > 0) {
      const resultOperation = InvestorApi.update(investors);

      resultOperation
        .then(() => {
          refreshView();
        })
        .catch(error => {
          showNotification('ra.notification.server', 'error', {
            messageArgs: { message: getIcError(error) }
          });
        });
    }
    return investors.length;
  };

  render() {
    return <RemoveButton {...this.props} updateMany={this.updateMany} />;
  }
}

const mapDispatchToProps = {
  refreshView
};

export default connect(
  null,
  mapDispatchToProps
)(RemoveOrganizationInvestorButton);
